export default __webpack_public_path__ + "static/enescu-ad79baf6cb6aec1d01e3db68eaad7dad.jpeg";